import { formatExperienceSearchSort } from './formatExperienceSearchSort'

export interface ExperienceSearchDateRange {
  checkIn?: string
  checkOut?: string
}

function formatDateRangeSuffix({ checkIn, checkOut }: ExperienceSearchDateRange): string {
  if (!checkIn) return ', Any dates'
  return checkOut && checkOut !== checkIn ? `, ${checkIn} to ${checkOut}` : `, ${checkIn}`
}

// Shared by both the activity entry (`experience_search_submitted`) and the committed-state entry
// (`last_experience_search`) -- same underlying search, same customer-facing summary, so one
// composer rather than two copies that could silently drift apart.
export function formatExperienceSearchDisplayText(
  searchQuery: string,
  dateRange: ExperienceSearchDateRange,
  sort: Experiences.SortTypes = 'type',
): string {
  return `Searched experiences for "${searchQuery}"${formatDateRangeSuffix(dateRange)}, sort: ${formatExperienceSearchSort(sort)}`
}
